module.exports = __webpack_public_path__ + "components/patterns/searchResultsFiltersOrderBy/search-results-filters-order-by.tpl.php";